var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-results-details" }, [
        _c(
          "div",
          { staticClass: "w-full flex flex-wrap justify-between spacer-b-2" },
          [
            _c("div", { staticClass: "count" }, [
              _c("span", [_vm._v(_vm._s(_vm.pagination.total))]),
              _vm._v(" Campaigns"),
            ]),
            _vm._v(" "),
            _c("campaign-sort", {
              model: {
                value: _vm.sort,
                callback: function ($$v) {
                  _vm.sort = $$v
                },
                expression: "sort",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex w-full spacer-x-3 spacer-y-3 bg-grey-light" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.search,
                expression: "search",
              },
            ],
            staticClass: "w-full",
            staticStyle: { border: "none", "padding-left": "20px" },
            attrs: {
              id: "search",
              placeholder: "Search campaign title or description",
            },
            domProps: { value: _vm.search },
            on: {
              keypress: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleGetCampaignsCallback.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.search = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "ladda-button",
            {
              staticClass: "btn btn-lg btn-primary flex-shrink-0 margin-l-2",
              attrs: { click: _vm.handleGetCampaignsCallback },
            },
            [_vm._v("\n        Search\n      ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dashboard-block" },
        [
          _c(
            "ul",
            { staticClass: "nav nav-tabs", attrs: { role: "tablist" } },
            [
              _c(
                "li",
                { class: { active: _vm.status === "active" } },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          params: { status: "active" },
                          query: _vm.$route.query,
                        },
                      },
                    },
                    [_vm._v("Active")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: { active: _vm.status === "draft" } },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          params: { status: "draft" },
                          query: _vm.$route.query,
                        },
                      },
                    },
                    [_vm._v("Drafts")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: { active: _vm.status === "archived" } },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          params: { status: "archived" },
                          query: _vm.$route.query,
                        },
                      },
                    },
                    [_vm._v("Archived")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.fetching
            ? _c("pickstar-loading", { staticClass: "m-t-lg" })
            : [
                !(_vm.campaigns && _vm.campaigns.length !== 0)
                  ? _c("no-results", [
                      _c("div", [_vm._v("There are no campaigns.")]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "list-items" },
                  _vm._l(_vm.campaigns, function (campaign) {
                    return _c("campaign-list-item", {
                      key: campaign.id,
                      attrs: { campaign: campaign },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "lazy-loading",
                  {
                    ref: "lazyLoading",
                    staticClass: "text-center",
                    attrs: {
                      loading: _vm.loading,
                      "reached-bottom": _vm.handleGetNextCampaignsCallback,
                    },
                  },
                  [
                    _c("pickstar-loading", {
                      attrs: { slot: "loading" },
                      slot: "loading",
                    }),
                    _vm._v(" "),
                    _c("span", {
                      attrs: { slot: "finished" },
                      slot: "finished",
                    }),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("\n        Campaigns\n      ")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }